import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule, Routes } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../constants';
import { ImportComponent } from './import.component';

const routes: Routes = [
  {
    path: '',
    component: ImportComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    RouterModule.forChild(routes),
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatListModule,
    MatButtonModule,
    MatIconModule,
    GalaxyPageModule,
  ],
  declarations: [ImportComponent],
  exports: [RouterModule],
  providers: [],
})
export class ImportModule {}
